/*
 *
 * Pci Actions
 *
 * @version 1.0.0
 * @author NEOSYN\user
 * @since 05-Nov-2024
 */

import { createRequestTypes, createAction, MakeRequest } from 'Store/actions/index'

export const actionTypes = {
  DO_NEED_SUPPORT: '@@Pci/need_support',
  DO_GET_PCI_DATA: '@@Pci/get_pci_data',
  DO_GET_COMPANY_DATA: '@@Pci/get_company_data',
  DO_GET_SHOPS: '@@Pci/get_shops',
  DO_COMPILE_QUESTIONNAIRE: '@@Pci/compile_questionnaire',
  DO_ANSWER_QUESTION: '@@Pci/answer_question',
  DO_SEND_QUESTIONNAIRE: '@@Pci/send_questionnaire',
  DO_CORRECT_QUESTIONNAIRE: '@@Pci/correct_questionnaire',
  DO_EDIT_QUESTIONNAIRE: '@@Pci/edit_questionnaire',
  DO_SET_SURVEY_DATA: '@@Pci/set_survey_data',
  DO_COMPLETE_QUESTIONNAIRE: '@@Pci/complete_questionnaire',
  DO_COMPLETED_REMEDIATION: '@@Pci/completed_remediation',
  DO_NAVIGATE_TO_PREVIOUS_QUESTION: '@@Pci/navigate_to_previous_question',
  DO_NAVIGATE_TO_NEXT_QUESTION: '@@Pci/navigate_to_next_question',
  NAVIGATE_TO_NEXT_QUESTION_SUCCESS: '@@Pci/navigate_to_next_question_success',
  DO_CORRECT_QUESTION: '@@Pci/correct_question',
  DO_REMEDY_QUESTIONS: '@@Pci/remedy_questions',
  DO_NAVIGATE_TO_NEXT_QUESTION_TO_REMEDY: '@@Pci/navigate_to_next_question_to_remedy',
  DO_REVIEW_QUESTION: '@@Pci/review_question',
  // @generator action:route:type

  ...createRequestTypes('@@Pci', 'NEED_SUPPORT'),
  ...createRequestTypes('@@Pci', 'GET_PCI_DATA'),
  ...createRequestTypes('@@Pci', 'GET_COMPANY_DATA'),
  ...createRequestTypes('@@Pci', 'GET_SHOPS'),
  ...createRequestTypes('@@Pci', 'COMPILE_QUESTIONNAIRE'),
  ...createRequestTypes('@@Pci', 'ANSWER_QUESTION'),
  ...createRequestTypes('@@Pci', 'SEND_QUESTIONNAIRE'),
  ...createRequestTypes('@@Pci', 'COMPLETED_REMEDIATION'),
  ...createRequestTypes('@@Pci', 'CORRECT_QUESTION')
  // @generator action:route:type:request
}

// ------------------------------------
// Actions
// ------------------------------------
// @generator action:route:request
/** @action request
* * Insert a description
* @name correctQuestion
* @return {object} - The action object
*/
export const correctQuestion = new MakeRequest('Pci', 'correct_question')
/** @action request
* * Insert a description
* @name getShops
* @return {object} - The action object
*/
export const getShops = new MakeRequest('Pci', 'get_shops')
/** @action request
* * Insert a description
* @name getCompanyData
* @return {object} - The action object
*/
export const getCompanyData = new MakeRequest('Pci', 'get_company_data')
/** @action request
* * Insert a description
* @name sendQuestionnaire
* @return {object} - The action object
*/
export const sendQuestionnaire = new MakeRequest('Pci', 'send_questionnaire')
/** @action request
* * Insert a description
* @name completedRemediation
* @return {object} - The action object
*/
export const completedRemediation = new MakeRequest('Pci', 'completed_remediation')
/** @action request
* * Insert a description
* @name answerQuestion
* @return {object} - The action object
*/
export const answerQuestion = new MakeRequest('Pci', 'answer_question')
/** @action request
* * Insert a description
* @name compileQuestionnaire
* @return {object} - The action object
*/
export const compileQuestionnaire = new MakeRequest('Pci', 'compile_questionnaire')
/** @action request
* * Insert a description
* @name needSupport
* @return {object} - The action object
*/
export const needSupport = new MakeRequest('Pci', 'need_support')
/** @action request
* * Insert a description
* @name getPciData
* @return {object} - The action object
*/
export const getPciData = new MakeRequest('Pci', 'get_pci_data')

// @generator action:route
/** @action
* * Insert a description
* @name ReviewQuestion
* @return {object} - The payload object
*/
export const doReviewQuestion = payload => createAction(actionTypes.DO_REVIEW_QUESTION, { payload })
/** @action
* * Insert a description
* @name NavigateToNextQuestionToRemedy
* @return {object} - The payload object
*/
export const doNavigateToNextQuestionToRemedy = payload => createAction(actionTypes.DO_NAVIGATE_TO_NEXT_QUESTION_TO_REMEDY, { payload })
/** @action
* * Insert a description
* @name RemedyQuestions
* @return {object} - The payload object
*/
export const doRemedyQuestions = payload => createAction(actionTypes.DO_REMEDY_QUESTIONS, { payload })
/** @action
* * Insert a description
* @name CorrectQuestion
* @return {object} - The payload object
*/
export const doCorrectQuestion = payload => createAction(actionTypes.DO_CORRECT_QUESTION, { payload })
/** @action
* * Insert a description
* @name NavigateToNextQuestion
* @return {object} - The payload object
*/
export const doNavigateToNextQuestion = payload => createAction(actionTypes.DO_NAVIGATE_TO_NEXT_QUESTION, { payload })
/** @action
* * Insert a description
* @name NavigateToNextQuestion
* @return {object} - The payload object
*/
export const doNavigateToNextQuestionSuccess = payload => createAction(actionTypes.NAVIGATE_TO_NEXT_QUESTION_SUCCESS, { payload })
/** @action
* * Insert a description
* @name CompleteQuestionnaire
* @return {object} - The payload object
*/
export const doCompleteQuestionnaire = payload => createAction(actionTypes.DO_COMPLETE_QUESTIONNAIRE, { payload })
/** @action
* * Insert a description
* @name SetSurveyData
* @return {object} - The payload object
*/
export const doSetSurveyData = payload => createAction(actionTypes.DO_SET_SURVEY_DATA, { payload })
/** @action
* * Insert a description
* @name EditQuestionnaire
* @return {object} - The payload object
*/
export const doEditQuestionnaire = payload => createAction(actionTypes.DO_EDIT_QUESTIONNAIRE, { payload })
/** @action
* * Insert a description
* @name CorrectQuestionnaire
* @return {object} - The payload object
*/
export const doCorrectQuestionnaire = payload => createAction(actionTypes.DO_CORRECT_QUESTIONNAIRE, { payload })
/** @action
* * Insert a description
* @name NavigateToPreviousQuestion
* @return {object} - The payload object
*/
export const doNavigateToPreviousQuestion = questionId => createAction(actionTypes.DO_NAVIGATE_TO_PREVIOUS_QUESTION, { questionId })
/** @action
* * Insert a description
* @name doCompletedRemediation
* @return {object} - The payload object
*/
export const doCompletedRemediation = payload => createAction(actionTypes.DO_COMPLETED_REMEDIATION, { payload })
/** @action
* * Insert a description
* @name AnswerQuestion
* @return {object} - The payload object
*/
export const doAnswerQuestion = payload => createAction(actionTypes.DO_ANSWER_QUESTION, { payload })
/** @action
* * Insert a description
* @name CompileQuestionnaire
* @return {object} - The payload object
*/
export const doCompileQuestionnaire = payload => createAction(actionTypes.DO_COMPILE_QUESTIONNAIRE, { payload })
/** @action
* * Insert a description
* @name doNeedSupport
* @return {object} - The payload object
*/
export const doNeedSupport = payload => createAction(actionTypes.DO_NEED_SUPPORT, { payload })
/** @action
* * Insert a description
* @name GetShops
* @return {object} - The payload object
*/
export const doGetShops = (payload) => createAction(actionTypes.DO_GET_SHOPS, { payload })
/** @action
* * Insert a description
* @name GetCompanyData
* @return {object} - The payload object
*/
export const doGetCompanyData = (payload) => createAction(actionTypes.DO_GET_COMPANY_DATA, { payload })
/** @action
* * Insert a description
* @name GetPciData
* @return {object} - The payload object
*/
export const doGetPciData = vatNumber => createAction(actionTypes.DO_GET_PCI_DATA, { vatNumber })
/** @action
* * Insert a description
* @name doSendQuestionnaire
* @return {object} - The payload object
*/
export const doSendQuestionnaire = payload => createAction(actionTypes.DO_SEND_QUESTIONNAIRE, { payload })
